// Externe Bibliotheken
import React, { Component, createRef, memo } from 'react';
import { Scrollbar } from 'smooth-scrollbar-react';

// Styles
import './overlayModal.scss';

class OverlayModal extends Component {
    componentDidMount() {
        if (window.$browserInfo.device === 'mobile') {
            document.querySelector('html').style.overflow = 'hidden';
        }
    }

    componentWillUnmount() {
        if (window.$browserInfo.device === 'mobile') {
            document.querySelector('html').removeAttribute('style');
        }
    }

    clickOutsideHandler(ref) {
        document.addEventListener('mousedown', (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                this.props.toggleModal();
            }
        });
    }

    render() {
        let elementRef = createRef();
        this.clickOutsideHandler(elementRef);

        return (
            <div className="modal-background-overlay-container">
                <div className={`modal-container ${this.props.name}`} ref={elementRef}>
                    {window.$browserInfo.device === 'mobile' && <div className="modal-mobile-background-layer"></div>}
                    <div className="modal-header">
                        <div className="title-row">
                            {this.props.displayName}
                            <i
                                className="modal-close material-symbols-outlined"
                                onClick={() => {
                                    document.querySelector('html').style.overflow = 'auto';
                                    this.props.toggleModal();
                                }}>
                                close
                            </i>
                        </div>
                        {this.props.tabs && window.$browserInfo.device !== 'mobile' && (
                            <div className="tab-row">
                                {Object.keys(this.props.tabs).map((tab) => {
                                    return (
                                        <div
                                            key={tab}
                                            className={`tab${tab === this.props.currentTab ? ' active' : ''}`}
                                            onClick={() => this.props.setTabName(tab)}>
                                            {this.props.tabs[tab]}
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                    {(this.props.scrollable || window.$browserInfo.device === 'mobile') &&
                    this.props.name !== 'accommodation-map' ? (
                        <Scrollbar>
                            <div className="modal-content">{this.props.children}</div>
                        </Scrollbar>
                    ) : (
                        <div className="modal-content">{this.props.children}</div>
                    )}
                </div>
            </div>
        );
    }
}

export default memo(OverlayModal);
